import { useDispatch } from 'react-redux'
import { sagaActions } from 'store/sagas/typeSagas'

const useClearReduxState = () => {
  const dispatch = useDispatch()

  const clearOrderCreateInput = () => {
    // bookingDate
    dispatch({
      type: sagaActions.UPDATE_ORDER_START_DATES,
      payload: null,
    })
    dispatch({
      type: sagaActions.UPDATE_ORDER_END_DATES,
      payload: null,
    })
    // porductVariants
    dispatch({
      type: sagaActions.RESET_ORDER_PRODUCT_VARIANTS,
    })
    // numberOfPeople
    dispatch({
      type: sagaActions.UPDATE_ORDER_NUMBER_OF_PEOPLE,
      payload: 1,
    })
    // purpose
    dispatch({
      type: sagaActions.UPDATE_ORDER_PURPOSE,
    })
    // saleOfGoods
    dispatch({
      type: sagaActions.UPDATE_ORDER_SALE_OF_GOODS,
      payload: false,
    })
    // entryFree
    dispatch({
      type: sagaActions.UPDATE_ORDER_ENTRY_FEE,
      payload: false,
    })
    // calendar
    dispatch({
      type: sagaActions.UPDATE_ORDER_CALENDAR,
      payload: {
        approval: false,
        organizer: undefined,
        eventName: undefined,
        publishableDate: undefined,
      },
    })
    // rate
    dispatch({
      type: sagaActions.UPDATE_ORDER_RATE,
      payload: { variantId: null, period: null },
    })
    // contact (event purpose)
    dispatch({
      type: sagaActions.UPDATE_ORDER_CONTACT_OF_REPRESENTATIVE,
      payload: {
        name: null,
        email: null,
        phone: null,
      },
    })
  }

  const clearOrderCreateInputDate = () => {
    // bookingDate
    dispatch({
      type: sagaActions.UPDATE_ORDER_START_DATES,
      payload: null,
    })
    dispatch({
      type: sagaActions.UPDATE_ORDER_END_DATES,
      payload: null,
    })
    // rate period
    dispatch({
      type: sagaActions.UPDATE_ORDER_RATE,
      payload: { variantId: null, period: null },
    })
  }

  const updateOrderCreateInputDate = (
    startDate: string,
    endDate: string,
    startPeriod: string,
    endPeriod: string
  ) => {
    // date
    dispatch({
      type: sagaActions.UPDATE_ORDER_START_DATES,
      payload: startDate,
    })
    dispatch({
      type: sagaActions.UPDATE_ORDER_END_DATES,
      payload: endDate,
    })
    // period
    dispatch({
      type: sagaActions.UPDATE_ORDER_START_TIME,
      payload: startPeriod,
    })
    dispatch({
      type: sagaActions.UPDATE_ORDER_END_TIME,
      payload: endPeriod,
    })
  }

  return {
    clearOrderCreateInput,
    clearOrderCreateInputDate,
    updateOrderCreateInputDate,
  }
}

export default useClearReduxState
